import { type IDataObject } from '@inpart-io/devtools-iap';
import { type MutationTree } from 'vuex';

import { type ICheckStatusState } from './types';

export const RECEIVE_CHECK_STATUS = 'RECEIVE_CHECK_STATUS';

export function getMutations<T extends IDataObject>(): MutationTree<ICheckStatusState<T>> {
    return {
        [RECEIVE_CHECK_STATUS](_state, { dobjId, status }: { dobjId: number; status: T }) {
            _state.statusList.set(dobjId, status);
        }
    };
}
